import useLanguageTranslate from "../../../hooks/useLanguageTranslate";

const FormTabs = ({ tabs, activeTab, onTabClick, className, label, error }) => {
  const translate = useLanguageTranslate();

  // Calculate dynamic width based on number of tabs
  const getButtonWidth = () => {
    if (tabs.length === 2) return "w-[50%]";
    if (tabs.length === 3) return "w-[33.333%]";
    if (tabs.length === 4) return "w-[25%]";
    return "flex-1"; // fallback for other cases
  };

  const buttonWidth = getButtonWidth();

  // Get rounded corner classes based on position
  const getRoundedClasses = (index) => {
    if (tabs.length === 1) return "rounded-[10px]";
    if (index === 0)
      return "rounded-tl-[10px] rounded-bl-[10px] rtl:rounded-tl-none rtl:rounded-bl-none rtl:rounded-tr-[10px] rtl:rounded-br-[10px]";
    if (index === tabs.length - 1)
      return "rounded-tr-[10px] rounded-br-[10px] rtl:rounded-tr-none rtl:rounded-br-none rtl:rounded-tl-[10px] rtl:rounded-bl-[10px]";
    return "";
  };

  // Get margin for overlapping borders
  const getMarginClass = (index) => {
    if (index === 0) return "";
    return "ml-[-1px] rtl:ml-0 rtl:mr-[-1px]";
  };

  return (
    <div className="w-full">
      {label && (
        <p className="label text-[#48535B] text-base not-italic font-normal leading-[26px] tracking-[-0.16px] mb-2">
          {label}
        </p>
      )}
      <div
        className={`flex !mt-0 ${
          error ? "mb-2" : ""
        } yesno-tab-box w-full relative !z-0 ${className}`}
        role="tablist"
      >
        {tabs.map((tab, index) => (
          <button
            key={tab.type}
            // Without this the browser treats these as submit buttons, so
            // picking a tab inside a <form> submits it.
            type="button"
            onClick={() => onTabClick(tab.type, tab)}
            className={`${
              activeTab == tab.type
                ? `bg-[#E3F8FF] text-[#00719A] text-base not-italic font-normal flex ${buttonWidth} box-border flex-col items-center shrink-0 px-4 py-[13px] border-2 border-solid border-[#00719A] h-[50px] justify-center z-10 ${getRoundedClasses(
                    index
                  )} ${getMarginClass(index)}`
                : `flex ${buttonWidth} h-[50px] flex-col items-center shrink-0 border bg-white px-4 py-[13px] border-solid border-[#DDE2E4] box-border justify-center ${getRoundedClasses(
                    index
                  )} ${getMarginClass(index)}`
            }`}
            role="tab"
            aria-selected={activeTab == tab.type}
          >
            <span
              className={`top_title text-center text-base not-italic font-normal leading-6 tracking-[-0.16px] ${
                activeTab == tab.type ? "text-[#00719A]" : "text-[#252C32]"
              }`}
            >
              {translate(tab.label_en, tab.label_ar)}
            </span>
            {tab.subtitle_en && (
              <span className="top_title text-center text-base not-italic font-normal leading-6 max767:w-6/12 max767:inline-block">
                {translate(tab.subtitle_en, tab.subtitle_ar)}
              </span>
            )}
          </button>
        ))}
      </div>
      {error && <p className="field-err text-red-500 text-sm">{error}</p>}
    </div>
  );
};

export default FormTabs;
